"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tab = _interopRequireDefault(require("./Tab"));

var _Tabs = require("./Tabs.style");

var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs,
      fullWidth = _ref.fullWidth,
      defaultSelectedIndex = _ref.defaultSelectedIndex,
      onIndexChange = _ref.onIndexChange,
      onTabChange = _ref.onTabChange;

  var _ref2 = (0, _react.useState)(defaultSelectedIndex),
      _ref3 = _slicedToArray(_ref2, 2),
      selectedIndex = _ref3[0],
      setSelectedIndex = _ref3[1];

  var isSelected = function isSelected(index) {
    return selectedIndex === index;
  };

  (0, _react.useEffect)(function () {
    onIndexChange(selectedIndex, tabs[selectedIndex]);
  }, [selectedIndex, onIndexChange, tabs]);
  return /*#__PURE__*/_react.default.createElement(_Tabs.NavItem, {
    fullWidth: fullWidth
  }, /*#__PURE__*/_react.default.createElement(_Tabs.TabList, {
    fullWidth: fullWidth
  }, tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab, index) {
    return /*#__PURE__*/_react.default.createElement(_Tab.default, {
      key: tab === null || tab === void 0 ? void 0 : tab.title,
      tabContent: tab,
      isSelected: isSelected(index),
      fullWidth: fullWidth,
      onClick: function onClick() {
        setSelectedIndex(index);
        onTabChange(tab === null || tab === void 0 ? void 0 : tab.title);
      },
      onKeyDown: function onKeyDown() {
        return setSelectedIndex(index);
      }
    });
  })));
};

Tabs.propTypes = {
  tabs: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string.isRequired
  })).isRequired,
  defaultSelectedIndex: _propTypes.default.number,
  fullWidth: _propTypes.default.bool,
  onIndexChange: _propTypes.default.func,
  onTabChange: _propTypes.default.func
};
Tabs.defaultProps = {
  defaultSelectedIndex: 0,
  fullWidth: false,
  onIndexChange: function onIndexChange() {},
  onTabChange: function onTabChange() {}
};
var _default = Tabs;
exports.default = _default;